import type { FC } from 'react';
import React from 'react';
import { styled } from '@compiled/react';

import Page16Icon from '@atlaskit/icon-object/glyph/page/16';
import { token } from '@atlaskit/tokens';

import { Link } from '@confluence/route-manager';
import { CONTEXT_PATH } from '@confluence/named-routes';

import type { ContentAccessDetailsQuery as ContentAccessDetailsQueryType } from './__types__/ContentAccessDetailsQuery';

type ContentDescriptionProps = {
	contentInfo?: ContentAccessDetailsQueryType;
	isLoading: boolean;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const PageDescriptionContainer = styled.div({
	display: 'flex',
	flex: '1 1 auto',
	alignItems: 'center',
	flexDirection: 'row',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const PageDescriptionLabel = styled.div({
	paddingLeft: token('space.100'),
	display: 'inline-block',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'a[data-testid="parent-page-link"]': {
		color: token('color.text'),
		textDecoration: 'underline',
	},
});

export const ContentDescription: FC<ContentDescriptionProps> = ({ contentInfo }) => {
	const path = contentInfo?.singleContent?.links?.webui;
	const pageUrl = `${CONTEXT_PATH}${path}`;

	return (
		<PageDescriptionContainer>
			<Page16Icon label="" />
			<PageDescriptionLabel>
				<Link to={pageUrl} target="_blank" testId="parent-page-link">
					{contentInfo?.singleContent?.title}
				</Link>
			</PageDescriptionLabel>
		</PageDescriptionContainer>
	);
};
